module.exports = __webpack_public_path__ + "img/sidebar_rlb_202627.798b8f44.png";